import { Component, Input } from '@angular/core';

@Component({selector: 'app-statsbox-graph',
  templateUrl: './statsbox-graph.component.html',
  styleUrls: ['./statsbox-graph.component.scss'],
  standalone: false,
})
export class StatsboxGraphComponent {
  @Input() iconUrl: string = '';
  @Input() iconWidth: string | number = 32;
  @Input() title: string;
  @Input() value: string|number;

}
